/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('./distribution_pie_chart');
require('./distribution_bar_chart');
require('./print_count_chart');

require('./select2.min');
require('rangeslider.js')

require('./custom.js');
require('./admin_create.js');
require('./customer_create.js');
